import styled from 'styled-components';

export const SelectNetworkStyled = styled.div<{ isOpen: boolean }>`
  margin-bottom: 20px;
  width: 100%;
  padding: 1px;
  border-radius: 8px;
  position: relative;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.neutral900};
    border-radius: 8px;
    padding: 0 16px;
    background: ${({ theme }) => theme.colors.neutral100};
    > img {
      margin-left: 16px;
      transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : '')};
      transition: all 300ms ease;
    }
  }
`;

export const SelectDropDown = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral900};
  border-radius: 8px;
  padding: 0 18px;
  background: ${({ theme }) => theme.colors.neutral100};

  div {
    height: 56px;
  }
`;

export const CollapsibleAbsolute = styled.div<{
  isOpen: boolean;
  height?: any;
}>`
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  max-height: ${({ isOpen, height }) => (isOpen ? `${height}` : '0')};
  overflow: hidden;
  transition: all ease 300ms;
  margin-bottom: ${({ isOpen }) => (isOpen ? '20px' : '0')};
  position: absolute;
  right: 0;
  left: 0;
  top: 60px;
  z-index: 1;
`;
